<template>
  <div class="h-full grid grid-rows-[auto_auto_1fr]">
    <ThreadsNav :show-center="false" show-back></ThreadsNav>
    <div class="flex flex-col items-center justify-center w-full">
      <h3 class="text-xl font-semibold">{{ $t(`Payment.balance`) }}</h3>
      <h1 class="text-[40px] leading-[56px] font-semibold mt-1 mb-10">
        $ {{ (user?.balance || 0).toFixed(2) }}
      </h1>

      <button class="btn btn-primary btn-wide mb-3" @click="clickWithdraw">
        {{ $t(`Buttons.withdrawSetting`) }}
      </button>
      <button
        class="btn btn-primary btn-wide"
        @click="router.push({ name: 'transactionRecords' })"
      >
        {{ $t(`Payment.incomeRecord`) }}
      </button>

      <div class="flex-1 flex justify-between w-full p-3">
        <div>{{ $t(`Payment.myRoleIncome`) }}</div>
        <VanPopover
          v-model:show="showPopover"
          :actions="actions"
          @select="onSelect"
        >
          <template #reference>
            <div class="flex items-center text-my-gray">
              {{ showMap[days as keyof typeof showMap] }}
              <i class="iconfont icon-down1 mt-0.5 ml-1" />
            </div>
          </template>
        </VanPopover>
      </div>
    </div>
    <div v-if="loading" class="text-center mt-10">
      <VanLoading color="#ABABAB" />
    </div>
    <div v-else-if="list.length === 0">
      <VanEmpty :description="$t('Message.noTxAvailable')" />
    </div>

    <ul v-else class="flex flex-col gap-2.5 overflow-auto w-full px-4">
      <li
        v-for="item in list"
        class="grid grid-cols-[auto_1fr_auto] grid-rows-[auto_auto] items-center"
        @click="
          router.push({
            name: 'transactionRecords',
            query: { mateId: item.mate.id },
          })
        "
      >
        <div class="w-8 row-span-2">
          <BaseImg :url="item.mate.mediaUrl" :width="80" />
        </div>
        <h2 class="ml-2">{{ item.mate.name }}</h2>

        <div class="row-span-2 text-primary text-base">
          +${{ item.totalAmount }}
        </div>
        <div class="flex items-center">
          <GenderBadge :gender="item.mate.gender" class="w-5" padding />
          <span class="text-my-gray">
            {{ $t(`Home.type.${item.mate.type}`) }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import api from "@/modules/api";
import { ApiGetTransactionOverview } from "@/apis/payment";
import { useI18n } from "vue-i18n";
import { sessionStorageGet } from "@/tools/sessionStorage";
import { useRouter } from "vue-router";

const user = ref<User>();

const list = ref<{ mate: Mate; totalAmount: number }[]>([]);
const loading = ref(false);
const { t } = useI18n();
const router = useRouter();

const showPopover = ref(false);

const showMap = {
  3: t(`Payment.recent.day`),
  7: t(`Payment.recent.week`),
  30: t(`Payment.recent.month`),
};

const days = ref(3);
// 通过 actions 属性来定义菜单选项
const actions = Object.entries(showMap).map(([key, value]) => {
  return {
    text: value,
    value: Number(key),
  };
});

const onSelect = (action: any) => {
  days.value = action.value;
  reloadList();
};

const reloadList = async () => {
  loading.value = true;
  const { data } = await ApiGetTransactionOverview({
    type: 1,
    recentDays: days.value,
  });
  list.value = data;
  loading.value = false;
};

const clickWithdraw = () => {
  router.push({ name: user.value?.paypal ? "withdrawal" : "paypal" });
};

onMounted(async () => {
  user.value = sessionStorageGet("user");
  reloadList();
  user.value = (await api.readUserHome()).data;
});
</script>
